import React from 'react'

export default function IntroApi () {
    return <div className="adobe-app-main">
        <iframe title="Photoshop API" frameBorder="0" className='adobe-app-iframe' src={`${process.env.REACT_APP_DISDK_ADOBE_EXPRESS_API}`} />
    </div>
}
